import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { CmsBlogExternalArticle } from 'types/cms/collection-types'

/**
 * Get the blog external articles from the CMS
 *
 * @param {'all' | Language} locale
 * @returns {Promise<CmsBlogExternalArticle[]>}
 */
const getBlogExternalArticles = async (locale: 'all' | Language = Language.DUTCH): Promise<CmsBlogExternalArticle[]> => {
  try {
    const { data } = await axios.get<CMSApiResponseBody<CmsBlogExternalArticle[]>>(
      `${process.env.CMS_API_URL}/blog-external-articles?locale=${locale}`
    )

    return data.data
  } catch (_) {
    return []
  }
}

export default getBlogExternalArticles
